import { SET_TARGET_ACCOUNT, UNSET_TARGET_ACCOUNT } from '../actions/types';

const initialState = {
  chosenAccount: {},
  didPickAccount: false,
};
export default function(state = initialState, action) {
  switch (action.type) {
    case SET_TARGET_ACCOUNT:
      return action.payload;
    case UNSET_TARGET_ACCOUNT:
      return initialState;
    default:
      return state;
  }
}
